"use client";

import { Command } from "cmdk";
import { type ComponentProps } from "react";

import { cn } from "../../utils";

export interface ComboboxEmptyProps extends ComponentProps<typeof Command.Empty> {}

const Empty = ({ ref, children, className, ...props }: ComboboxEmptyProps) => (
  <Command.Empty ref={ref} className={cn("px-2 py-2 text-center text-sm text-neutral-50", className)} {...props}>
    {children}
  </Command.Empty>
);

Empty.displayName = Command.Empty.displayName;

export default Empty;
